import Icon from '../components/Icon.vue'

Icon.register({
  'user-ninja': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M325.4 289.2c68.6 6.1 122.6 63 122.6 133.2v41.6c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-41.6c0-70.2 54-127.1 122.6-133.2l101.4 101.4zM32 192c0-33.4 17.1-62.8 43.1-80-26-17.2-43.1-46.6-43.1-80 32 0 60.1 15.8 77.5 39.8 20.9-42.4 64.1-71.8 114.5-71.8 70.7 0 128 57.3 128 128s-57.3 128-128 128c-58.8 0-107.7-39.8-122.8-93.7-17.4 18.2-41.9 29.7-69.2 29.7zM176 96c-17.7 0-32 14.3-32 32h160c0-17.7-14.3-32-32-32h-96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-ninja.js
// module id = 2070
// module chunks = 0